module.exports = __webpack_public_path__ + "img/katarina_bedrooms_7.7fe33021.jpg";